export const COMMON_THEME = {
  ERROR: 'rgb(255, 64, 88)',
  SUCCESS: '#4bca81',
  HIGHLIGHT: '#46aef7',
} as const

export const LIGHT_THEME = {
  PRIMARY: '#fff',
  SECONDARY: '#F2F2FA',
  TERTIARY: '#EAECF3',
  TXT: '#0e091e',
  SECONDARY_TXT: '#888',
  OK_BTN_TXT: '#fff',
  OK_BTN_BG: '#46aef7',
  YELLOW: '#E9BF2E',
  BORDER: '#d9d9d9',
  TAB_BG: '#ccc',
} as const

export const DARK_THEME = {
  PRIMARY: '#0e091e',
  SECONDARY: '#2c223a',
  TERTIARY: '#3f394c',
  TXT: '#fff',
  SECONDARY_TXT: '#c4c5c5',
  OK_BTN_TXT: '#46aef7',
  OK_BTN_BG: '#fff',
  YELLOW: '#ffff1f',
  BORDER: '#fff',
  TAB_BG: '#191F26',
} as const
